var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 131,
    viewBox: "0 0 189 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6182 0.5H135.382C164.551 0.5 188.211 21.4256 188.497 47.126H153.647V35.8916C153.647 32.2984 150.4 29.4952 146.506 29.4951H42.5264C38.6324 29.4952 35.3848 32.2984 35.3848 35.8916V95.1377C35.3849 98.7308 38.6325 101.533 42.5264 101.533H146.506C150.4 101.533 153.647 98.7308 153.647 95.1377V83.9023H188.497C188.194 109.59 164.54 130.5 135.382 130.5H53.6182C24.2389 130.5 0.5 109.346 0.5 83.4023V47.5977C0.5 21.6537 24.2389 0.5 53.6182 0.5Z",
    fill: "#6941E6",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.0bd2dc82c62e9fdd16d43966f14fa1b6.svg";
export { ForwardRef as ReactComponent };